import React, { useEffect, useState } from 'react';
import { ButtonGroup, Button } from '../ui-kit';
import { remove } from 'lodash';

const ToggleButtonSelect = props => {
  const { options, values, onChange, type } = props;
  const [selectedValues, setSelectedValues] = useState(values);

  useEffect(() => {
    onChange(selectedValues);
  }, [selectedValues]);

  const updateCheckbox = value => {
    // Remove value from the selected list if already selected
    // If it's not already selected, append value to the selected list
    if (selectedValues.includes(value)) {
      const newSelectedValues = [...selectedValues];
      remove(newSelectedValues, v => v === value);
      setSelectedValues(newSelectedValues);
    } else {
      setSelectedValues([...selectedValues, value]);
    }
  };

  const updateRadio = value => {
    if (selectedValues.includes(value)) {
      setSelectedValues([]);
    } else {
      setSelectedValues([value]);
    }
  };

  const handleOnClick = value => {
    if (type === 'checkbox') {
      return updateCheckbox(value);
    }

    return updateRadio(value);
  };

  return (
    <ButtonGroup>
      {options.map(option => (
        <Button
          key={option.value}
          value={option.value}
          onClick={() => handleOnClick(option.value)}
          variant={selectedValues.includes(option.value) ? 'primary' : 'outline-secondary'}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ToggleButtonSelect;
